// extracted by mini-css-extract-plugin
export default {"centerItem":"styles---centerItem---Don8Y"};